import TabLayout, { TabLayoutProps } from "layout/TabLayout";
import { Exact, SkillQuestionsQuery } from "@generated/graphql";
import { QueryResult } from "@apollo/client";
import { QUESTIONS_TABS_VALUES } from "constants/global";
import QuestionList from "./components/QuestionList";

export type QuestionsProps = {
  skillQuery: QueryResult<SkillQuestionsQuery, Exact<{ skillId: string }>>;
};

const Questions = ({ skillQuery }: QuestionsProps) => {
  const TABS: TabLayoutProps["tabs"] = [
    {
      id: QUESTIONS_TABS_VALUES.confirmed,
      title: "Подтвержденные вопросы",
      component: (
        <QuestionList
          isConfirmed
          skillQuery={skillQuery}
        />
      ),
      sx: { marginTop: 1 },
    },
    {
      id: QUESTIONS_TABS_VALUES.unconfirmed,
      title: "Неподтвержденные вопросы",
      component: <QuestionList skillQuery={skillQuery} />,
      sx: { marginTop: 1 },
    },
  ];
  return (
    <TabLayout
      tabs={TABS}
      defaultTab='confirmed'
      withSearchParams
    />
  );
};

export default Questions;
